import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Constants from "../../utils/constants";
import apiClient from "../../services/apiClient";
import toast from "../../utils/toast";
import { getLocalData } from "../../services/storageManager";

const initialState = {
    shiftList: [],
    loading: false,
    error: null,
}

export const getAllShifts = createAsyncThunk(
    'getShifts',
    async (data, thunkAPI) => {
        const selectedListId=data.selectedDept.id;
        const accessToken=JSON.parse(getLocalData('accessToken') || '{}');

        const startTime =  new Date().setHours(0, 0, 0, 0);
        const endTime = startTime + 86400000;
        return await apiClient({
            url: Constants.API.BASE_URL+Constants.API.DEPARTMENT.GET_ALL+'/'+selectedListId+'/'+Constants.API.SHIFT.GET_ALL,
            method: 'GET',
            params: {
                startTime: startTime,
                endTime: endTime,
            },
            headers:{
                token:accessToken
            }
        }, true)
            .then((data) => data.data)
            .catch((error) => {
                return thunkAPI.rejectWithValue(error)
            })
    }
)

const shiftsSlice = createSlice({
    name: 'shifts',
    initialState,
    reducers: {
        clearError(state, action) {
            state.error = null;
        }
    },
    extraReducers: (builder) => {
        /**Action--->get Shifts/tasks */
        builder
            .addCase(getAllShifts.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(getAllShifts.fulfilled, (state, action) => {
                state.error = null;
                state.loading = false;
                state.shiftList = action.payload;
            })
            .addCase(getAllShifts.rejected, (state, action) => {
                state.loading = false;
                toast.error(Constants.ERROR_MESSAGES.ERR_NETWORK);
            })
    }
})

export const { clearError } = shiftsSlice.actions;
export const getLoading = (state) => state.shifts.loading;
export const getError = (state) => state.shifts.error;
export const getshifts = (state) => state.shifts.shiftList || [];

export default shiftsSlice.reducer;